type NonNullableKeys<T> = {
  [K in keyof T]: Exclude<T[K], null> extends never ? never : K;
}[keyof T];

export const removeNullKeysFromObject = <T>(obj: T): Pick<T, NonNullableKeys<T>> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => {
      if (item === Object(item) && !(item instanceof Date)) {
        return removeNullKeysFromObject(item);
      }
      return item;
    }) as any;
  }

  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, value]) => value != null)
      .map(([key, value]) => [
        key,
        value === Object(value) && !(value instanceof Date) ? removeNullKeysFromObject(value) : value,
      ]),
  ) as Pick<T, NonNullableKeys<T>>;
};
